// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"565":"nine-box","884":"am"}[chunkId] || chunkId) + "." + {"565":"1f36b784","629":"cd21e849","636":"e0b59052","884":"62c4de12"}[chunkId] + ".css";
};